import { useTranslation } from 'react-i18next';
import { ActionIcon, Divider, SimpleGrid, Stack, Switch, Tooltip } from '@mantine/core';

import { REACTIONS } from './reactions';
import classes from './reaction-picker.module.css';
import { useSoundSettings } from './sounds';

export function ReactionPicker({ onPick }: Readonly<{ onPick: (reactionId: string) => void }>) {
    const { t } = useTranslation('reactions');
    const { reactions: soundOn, setReactions: setSoundOn } = useSoundSettings();

    return (
        <Stack gap="xs">
            <SimpleGrid aria-label={t('picker.label')} cols={4} role="group" spacing="xs" verticalSpacing="xs">
                {REACTIONS.map(({ id, emoji }) => (
                    <Tooltip key={id} label={t(`items.${id}`)}>
                        <ActionIcon
                            aria-label={t(`items.${id}`)}
                            size="lg"
                            variant="subtle"
                            onClick={() => {
                                onPick(id);
                            }}
                        >
                            <span className={classes.emoji}>{emoji}</span>
                        </ActionIcon>
                    </Tooltip>
                ))}
            </SimpleGrid>
            <Divider />
            <Switch
                checked={soundOn}
                label={t('sounds.toggle')}
                size="sm"
                onChange={(event) => {
                    setSoundOn(event.currentTarget.checked);
                }}
            />
        </Stack>
    );
}
